import { render, staticRenderFns } from "./CaseCardList.vue?vue&type=template&id=1d2b8de8"
import script from "./CaseCardList.vue?vue&type=script&lang=ts"
export * from "./CaseCardList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports